import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RequestService } from '@app/_services/request.service';
import { authorityIds, operations, subAuthorities } from '@app/enums';

@Injectable({ providedIn: 'root' })
export class AdvisorApiService {
  constructor(private REQ: RequestService) {}

  getAdvisorList(): Observable<any> {
    const qry = {
      params: {},
      user_data: {
        authority: authorityIds.OSMA_ADVISOR,
        sub_authority: subAuthorities.ADVISOR.LIST,
        operation: operations.LIST,
        data: 'NA',
        format: 'json',
      },
    };
    return this.REQ.get('osma/advisor', { query: JSON.stringify(qry) });
  }
}
